import { reactive } from 'vue';

export type EditorTab = 'editor' | 'rules' | 'preview';

// Per-plan active tab (Editor / Rules / Preview), remembered for the session only.
// This is module-level reactive state — it survives surface switches and plan
// switches but is intentionally NOT persisted to localStorage or the exported
// bundle. Keyed by battlepack + plan name so identically-named plans in different
// packs don't share a tab.
const tabByPlan = reactive<Record<string, EditorTab>>({});

export function planTabKey(battlePack: string | null | undefined, plan: string): string {
  return `${battlePack ?? ''}::${plan}`;
}

export function getPlanTab(key: string): EditorTab {
  return tabByPlan[key] ?? 'editor';
}

export function setPlanTab(key: string, tab: EditorTab): void {
  tabByPlan[key] = tab;
}
